import { render, staticRenderFns } from "./threejs3.vue?vue&type=template&id=187a19ca&scoped=true"
import script from "./threejs3.vue?vue&type=script&lang=js"
export * from "./threejs3.vue?vue&type=script&lang=js"
import style0 from "./threejs3.vue?vue&type=style&index=0&id=187a19ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187a19ca",
  null
  
)

export default component.exports